import { useState } from 'react'

const FAQS: { q: string; a: string }[] = [
  {
    q: 'How do auditions get into RepTree?',
    a: 'Forward any casting email to your RepTree address and it lands as a ready-to-track audition — client matched, role and deadline parsed. You can also paste a Google-Sheets audition log to bulk-import your whole history in seconds, or add one by hand.',
  },
  {
    q: 'Where do my clients’ self-tapes live?',
    a: 'In your own branded vault — kept permanently and searchable, never expiring like a WeTransfer link. Collect on a per-actor upload link, review versions, request retakes, reorder takes, and release the final cut to casting.',
  },
  {
    q: 'What do my clients see?',
    a: 'Each actor gets a calm, mobile-first portal (installable like an app) showing exactly where every audition stands — submitted, callback, offer, booked — plus a place to upload their next tape. No more status-check texts.',
  },
  {
    q: 'How does pricing work?',
    a: 'A flat $20 per seat per month. The owner plus one teammate are free, so a solo agent pays nothing and a duo still pays nothing. Your first month is free and you can cancel anytime.',
  },
  {
    q: 'Can I bring my team and set permissions?',
    a: 'Yes. Invite teammates, choose granular roles, and assign specific clients to specific people — members only see what they’re assigned unless you grant broader access. Strict tenant isolation is enforced at the database level.',
  },
  {
    q: 'Is my data secure?',
    a: 'Every record is protected by row-level security so businesses can never see each other’s data, the server authorizes every request by role and permission, and self-tape links are signed and short-lived. Security was built in from the first migration, not bolted on.',
  },
]

function Item({ q, a }: { q: string; a: string }) {
  const [open, setOpen] = useState(false)
  return (
    <div className="row-rule">
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between gap-4 py-5 text-left"
        aria-expanded={open}
      >
        <span className="font-display text-lg">{q}</span>
        <span
          className={`grid h-7 w-7 shrink-0 place-items-center rounded-full border transition hairline ${open ? 'rotate-45' : ''}`}
          aria-hidden
        >
          +
        </span>
      </button>
      <div
        className="grid transition-all duration-300"
        style={{ gridTemplateRows: open ? '1fr' : '0fr' }}
      >
        <div className="overflow-hidden">
          <p className="pb-5 pr-10 text-[color:rgb(var(--muted))]">{a}</p>
        </div>
      </div>
    </div>
  )
}

export function FAQ() {
  return (
    <div className="mx-auto max-w-3xl">
      {FAQS.map((f) => (
        <Item key={f.q} {...f} />
      ))}
    </div>
  )
}
